import { Tag } from 'antd';
import { useMonitorActions } from 'src/store/monitor_beta/monitorStore';

export const AlertLocationTag = ({ location }: { location?: { lat?: number; lng?: number } }) => {
  const { flyTo } = useMonitorActions();

  const handleClick = () => {
    if (location && (location.lat != null || location.lng != null)) {
      flyTo({
        center: [location.lng ?? 0, location.lat ?? 0],
        zoom: 14,
      });
    }
  };

  return (
    <Tag onClick={handleClick} style={{ cursor: 'pointer' }}>
      {location && (location.lat != null || location.lng != null) ? (
        <div>
          {location.lat != null && `Lat: ${location.lat.toFixed(5)}`}
          {location.lat != null && location.lng != null && ', '}
          {location.lng != null && `Lng: ${location.lng.toFixed(5)}`}
        </div>
      ) : (
        'Location not available'
      )}
    </Tag>
  );
};
